import debounce from 'debounce';
import Select from './Select';

export default {
	mixins: [Select],
	data() {
		return {
			results: [],
			loading: false,
		}
	},
	methods: {
		onSearchChange(query) {
			if(!query) {
				return;
			}

			this.loading = true; //Set loading immediately to hide "no results" message
			this.debounceSearch(query);
		},
		debounceSearch: debounce(function(query) { this.search(query) }, 250),
		search(query) {
			return Promise.reject("Not implemented");
		},
		/**
		 * Get full option object corresponding to the given id from the vuex cache
		 * @param ids
		 * @returns {*[]|*}
		 */
		getFromCache(ids) {
			if(this.multiple) {
				let selected = Array.isArray(ids) ? ids : [ids];
				return selected.map(id => this.getItemFromCache(id)).filter(Boolean);
			} else {
				return this.getItemFromCache(ids);
			}
		},

		getItemFromCache(id) {
			return null;
		},

		/**
		 * Add full option objects to the vuex cache
		 * @param items
		 */
		addToCache(items) {
			if(Array.isArray(items)) {
				items.map(item => this.addItemToCache(item));
			} else {
				this.addItemToCache(items);
			}
		},

		addItemToCache(item) {
		},

		/**
		 * Get full objects for initial value ids
		 */
		setInitialValue() {
			this.selected = this.getFromCache(this.value);
		},
	},
	watch: {
        results() {
            this.addToCache(this.results);

            if(this.value && !this.multiple) {
                this.selected = this.getItemFromCache(this.value);
            }
        },
		value(value) {
			if(this.multiple && !this.selected.length && value.length){
				this.selected = this.getFromCache(value);
			} else {
				if(!this.selected) {
					this.selected = this.getFromCache(value);
				}
			}
		},
		/**
		 * Only return object ids in value
		 * Add selected objects to the cache so they can be rendered properly later
		 * @param selected
		 */
		selected(selected) {
			this.addToCache(selected);

			if(Array.isArray(selected)) {
				this.$emit('input', selected.filter(member => member).map(member => member.id));
			} else {
				this.$emit('input', selected ? selected.id : null);
			}
		},
	},
}
